import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import OwnerList from './owner-list.component';
import OwnerCreate from './owner-create.component';
import OwnerView from './owner-view.component';
import OwnerEdit from './owner-edit.component';
import OwnerCopy from './owner-copy.component';
import OwnerDelete from './owner-delete.component';

interface Props {
  root?: string;
}

export const OwnerRoute: React.FunctionComponent<Props> = (props) => {

  return (
    <Switch>
      <Route path={(props.root||'') + '/owner/create'} component={OwnerCreate } />
      <Route path={(props.root||'') + '/owner/view'} component={OwnerView } />
      <Route path={(props.root||'') + '/owner/edit'} component={OwnerEdit } />
      <Route path={(props.root||'') + '/owner/copy'} component={OwnerCopy } />
      <Route path={(props.root||'') + '/owner/delete'} component={OwnerDelete } />
      <Route path={(props.root||'') + '/owner'} render={(params) => <OwnerList {...params} root={props.root} />} /> 
    </Switch>
  );
}
